/**
 * Landing-only Kaching helpers: default bundle, colour chips, size pills.
 */
(function () {
  var root = document.querySelector('.plumelle-kaching-landing');
  if (!root) return;

  var enhancing = false;

  function syncSelectionClass() {
    var selected = !!root.querySelector('.kaching-bundles input[type="radio"]:checked, .kaching-bundles__bar--selected');
    root.classList.toggle('pkl-has-selection', selected);
  }

  function placeAtcUnderOpenBundle() {
    var atc = root.querySelector('.pkl-atc');
    if (!atc) return;
    var bar =
      root.querySelector('.kaching-bundles__bar--selected') ||
      root.querySelector('.kaching-bundles__bar:has(input:checked)');
    if (bar) {
      var gift = bar.querySelector('.kaching-bundles__free-gift');
      var container = bar.querySelector('.kaching-bundles__bar-container');
      if (gift && container) {
        if (gift.parentElement !== container) container.appendChild(gift);
        if (atc.parentElement !== container || atc.nextElementSibling !== gift) {
          container.insertBefore(atc, gift);
        }
        if (!atc.dataset.pklLabelGuard) {
          atc.dataset.pklLabelGuard = '1';
          atc.addEventListener(
            'mousedown',
            function (e) {
              e.stopPropagation();
            },
            true
          );
        }
        return;
      }
      if (atc.previousElementSibling !== bar) {
        bar.insertAdjacentElement('afterend', atc);
      }
      return;
    }
    var widget = root.querySelector('kaching-bundle');
    if (widget && atc.previousElementSibling !== widget) {
      widget.insertAdjacentElement('afterend', atc);
    }
  }

  function enhanceSwatches() {
    root.querySelectorAll('.kaching-bundles__swatch-dropdown').forEach(function (dd) {
      if (dd.dataset.pklSwatches === '1') return;
      var combo = dd.querySelector('[role="combobox"]');
      if (!combo) return;
      if (combo.getAttribute('aria-expanded') !== 'true') {
        try {
          combo.click();
        } catch (e) {}
      }
      var listId = combo.getAttribute('aria-controls');
      var list =
        (listId && document.getElementById(listId)) ||
        dd.querySelector('[role="listbox"]');
      if (!list) return;
      var opts = list.querySelectorAll('[role="option"]');
      if (!opts.length) return;

      var row = document.createElement('div');
      row.className = 'pkl-swatch-row';
      row.setAttribute('data-name', dd.getAttribute('data-name') || combo.getAttribute('aria-label') || '');

      Array.prototype.forEach.call(opts, function (opt) {
        var value = opt.getAttribute('data-value') || '';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pkl-swatch-pill';
        btn.setAttribute('data-value', value);
        var swatch = opt.querySelector('.kaching-bundles__swatch');
        if (swatch) btn.appendChild(swatch.cloneNode(true));
        var lab = document.createElement('span');
        lab.textContent = value;
        btn.appendChild(lab);
        btn.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          pickSwatch(dd, value);
          var bar = dd.closest('.kaching-bundles__bar');
          if (dd.classList.contains('pkl-follow-color')) {
            dd.dataset.pklUnlocked = '1';
          } else if (bar) {
            setTimeout(function () {
              syncFollowColors(bar);
            }, 60);
          }
        });
        row.appendChild(btn);
      });

      dd.appendChild(row);
      dd.dataset.pklSwatches = '1';
      syncSwatchRow(dd);
    });
  }

  function pickSwatch(dd, value) {
    var combo = dd.querySelector('[role="combobox"]');
    if (!combo) return;
    function clickOpt() {
      var listId = combo.getAttribute('aria-controls');
      var list =
        (listId && document.getElementById(listId)) ||
        dd.querySelector('[role="listbox"]');
      var opt = list && list.querySelector('[data-value="' + value.replace(/"/g, '') + '"]');
      if (opt) {
        opt.click();
        syncSwatchRow(dd);
        return true;
      }
      return false;
    }
    if (!clickOpt()) {
      if (combo.getAttribute('aria-expanded') !== 'true') {
        try {
          combo.click();
        } catch (e) {}
      }
      setTimeout(function () {
        clickOpt();
        syncSwatchRow(dd);
      }, 40);
    }
  }

  function syncSwatchRow(dd) {
    var current = dd.getAttribute('data-value') || '';
    var row = dd.querySelector('.pkl-swatch-row');
    if (!row) return;
    row.querySelectorAll('.pkl-swatch-pill').forEach(function (btn) {
      btn.classList.toggle('is-selected', btn.getAttribute('data-value') === current);
    });
  }

  function otherColorLabel() {
    return (root.getAttribute('data-pkl-other-color') || 'Other colour').trim();
  }

  function updateMatchedColor(dd) {
    var matched = dd.querySelector('.pkl-matched-color');
    if (!matched) return;
    var current = dd.getAttribute('data-value') || '';
    var pill = dd.querySelector('.pkl-swatch-pill[data-value="' + current.replace(/"/g, '') + '"]');
    matched.innerHTML = '';
    if (pill) {
      var swatch = pill.querySelector('.kaching-bundles__swatch');
      if (swatch) matched.appendChild(swatch.cloneNode(true));
      var lab = document.createElement('span');
      lab.textContent = current;
      matched.appendChild(lab);
    }
    var sel = dd.querySelector('.pkl-other-color-select');
    if (sel && dd.dataset.pklUnlocked !== '1') sel.value = '';
  }

  function syncFollowColors(bar) {
    if (!bar) return;
    var products = bar.querySelectorAll('.kaching-bundles__bundle-products__product');
    if (products.length < 2) return;
    var primaryDd = products[0].querySelector('.kaching-bundles__swatch-dropdown');
    if (!primaryDd) return;
    var color = primaryDd.getAttribute('data-value');
    if (!color) return;
    for (var i = 1; i < products.length; i++) {
      var dd = products[i].querySelector('.kaching-bundles__swatch-dropdown');
      if (!dd || dd.dataset.pklUnlocked === '1') {
        if (dd) updateMatchedColor(dd);
        continue;
      }
      if (dd.getAttribute('data-value') !== color) {
        pickSwatch(dd, color);
      }
      updateMatchedColor(dd);
    }
  }

  function enhanceFollowColors() {
    root.querySelectorAll('.kaching-bundles__bar').forEach(function (bar) {
      var products = bar.querySelectorAll('.kaching-bundles__bundle-products__product');
      if (products.length < 2) return;
      for (var i = 1; i < products.length; i++) {
        var dd = products[i].querySelector('.kaching-bundles__swatch-dropdown');
        if (!dd) continue;
        dd.classList.add('pkl-follow-color');
        var row = dd.querySelector('.pkl-swatch-row');
        if (!row) continue;
        if (!dd.querySelector('.pkl-matched-color')) {
          var matched = document.createElement('div');
          matched.className = 'pkl-matched-color';
          dd.appendChild(matched);
        }
        if (!dd.querySelector('.pkl-other-color-select')) {
          var sel = document.createElement('select');
          sel.className = 'pkl-other-color-select';
          sel.setAttribute('aria-label', otherColorLabel());
          var blank = document.createElement('option');
          blank.value = '';
          blank.textContent = otherColorLabel();
          sel.appendChild(blank);
          row.querySelectorAll('.pkl-swatch-pill').forEach(function (btn) {
            var opt = document.createElement('option');
            opt.value = btn.getAttribute('data-value') || '';
            opt.textContent = btn.getAttribute('data-value') || '';
            sel.appendChild(opt);
          });
          sel.addEventListener('change', function () {
            if (!sel.value) {
              dd.dataset.pklUnlocked = '';
              syncFollowColors(bar);
              return;
            }
            dd.dataset.pklUnlocked = '1';
            pickSwatch(dd, sel.value);
            updateMatchedColor(dd);
          });
          dd.appendChild(sel);
        }
        updateMatchedColor(dd);
      }
      syncFollowColors(bar);
    });
  }

  function enhanceSelects() {
    root.querySelectorAll('select.kaching-bundles__bar-variant-select').forEach(function (sel) {
      if (sel.dataset.pklPills === '1') {
        syncPills(sel);
        return;
      }
      sel.dataset.pklPills = '1';
      sel.classList.add('pkl-select-hidden');
      var wrap = document.createElement('div');
      wrap.className = 'pkl-size-pills';
      wrap.setAttribute('data-name', sel.getAttribute('aria-label') || sel.getAttribute('data-name') || '');
      sel.parentNode.insertBefore(wrap, sel);
      Array.prototype.forEach.call(sel.options, function (opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pkl-size-pill';
        btn.textContent = opt.textContent.trim();
        btn.setAttribute('data-value', opt.value);
        btn.addEventListener('click', function (ev) {
          ev.preventDefault();
          sel.value = opt.value;
          sel.setAttribute('data-value', opt.value);
          sel.dispatchEvent(new Event('input', { bubbles: true }));
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          syncPills(sel);
        });
        wrap.appendChild(btn);
      });
      syncPills(sel);
    });
  }

  function syncPills(sel) {
    var wrap = sel.previousElementSibling;
    if (!wrap || !wrap.classList.contains('pkl-size-pills')) return;
    var current = sel.value;
    wrap.querySelectorAll('.pkl-size-pill').forEach(function (btn) {
      btn.classList.toggle('is-selected', btn.getAttribute('data-value') === current);
    });
  }

  function enhance() {
    if (enhancing) return;
    enhancing = true;
    try {
      syncSelectionClass();
      enhanceSwatches();
      enhanceSelects();
      enhanceFollowColors();
      placeAtcUnderOpenBundle();
      root.querySelectorAll('.kaching-bundles__swatch-dropdown[data-pkl-swatches="1"]').forEach(syncSwatchRow);
    } finally {
      enhancing = false;
    }
  }

  var timer = null;
  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(enhance, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance);
  } else {
    enhance();
  }

  root.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('.kaching-bundles input[type="radio"]')) {
      syncSelectionClass();
      placeAtcUnderOpenBundle();
    }
  });

  try {
    var obs = new MutationObserver(schedule);
    obs.observe(root, { childList: true, subtree: true });
  } catch (e) {}

  setTimeout(enhance, 400);
  setTimeout(enhance, 1200);
  setTimeout(enhance, 2500);
})();
